import React, { useState } from "react";

import { 
  CircularProgress, 
  Container, 
  Paper, 
  Typography, 
  Divider, 
} from "@mui/material";
import { useSchedule } from "../../../contexts/ScheduleContext";
import { useLogger } from "../../../contexts/LoggerContext";
import { GameSelector } from "../../General/GameSelector";
import { GameLogger } from "./GameLogger";

export const GameLoggerRoot = () => {
    const { games, isLoading, error } = useSchedule();
    const { selectedGame, setSelectedGame } = useLogger();

    if (isLoading) {
        return (
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4, textAlign: 'center' }}>
                <CircularProgress />
                <Typography>Loading games...</Typography>
            </Container>
        );
    }

    if (error) {
        return (
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                    <Typography color="error">Error loading games: {error}</Typography>
                </Paper>
            </Container>
        );
    }

    if (selectedGame) {
        return <GameLogger/>;
    }

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Game Logger
                </Typography>
                <Divider sx={{ mb: 3 }} />
                <GameSelector 
                    games={games} 
                    onGameSelected={setSelectedGame}
                    label="Select a Game from Schedule"
                    showPaper={true}
                />
            </Paper>
        </Container>
    );
};


